import { useModals } from 'almanac-ui/Modal'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { Button } from 'blaze-ui/Button'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { EndReviewDrawer } from 'components/ReviewSummaryModal/EndReviewModal/EndReviewDrawer'
import { EndReviewModal } from 'components/ReviewSummaryModal/EndReviewModal/EndReviewModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import useResponsiveFunction from 'hooks/useResponsiveFunction'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

interface Props {
  request: InformalFeedbackRequest
}

export const EndReviewButton = observer(({ request, ...props }: Props & ButtonProps) => {
  const { openModal } = useModals()
  const { drawersStore } = useRootStore()
  const { isMobile } = useResponsiveDesign()
  const openEndReview = useResponsiveFunction({
    mobileFunction: () => drawersStore.openDrawer(EndReviewDrawer, { request }),
    defaultFunction: () => openModal(EndReviewModal, { request }),
  })

  return (
    <Button {...props} size={isMobile ? 'lg' : 'md'} onPress={openEndReview}>
      End Review
    </Button>
  )
})
